import React, { Component } from "react";
import AssociatePerformance from "./AssociatePerformance";
import AssociateFilterContextProvider from "./context/AssociateFilterContext";
import AssociateFilter from "./AssociateFilter";
import CapabilityContextProvider from "../global/context/CapabilityContext";
import AssociatePerformanceContextProvider from "./context/AssociatePerformanceContext";

class Associates extends Component {
    render() {
        return (
            <CapabilityContextProvider>
                <AssociateFilterContextProvider>
                    <AssociateFilter />
                    <AssociatePerformanceContextProvider>
                        <AssociatePerformance />
                    </AssociatePerformanceContextProvider>
                </AssociateFilterContextProvider>
            </CapabilityContextProvider>
        )
    }
}
export default Associates


// WEBPACK FOOTER //
// ./src/components/stageassociate/Associates.js